module.exports = __webpack_public_path__ + "img/Email.9f9efce3.svg";